import React from "react";
import styled from "styled-components";

const Self = styled.div`
  width: 100%;
  position: absolute;
  z-index: 1000;
  left: 0;
  bottom: 0;
  background-color: rgba(32, 32, 32, 0.8);
  color: #fff;
  display: none;

  ${({ isShow }) => isShow && `display: block;`}
`;

const GuideText = styled.div`
  padding: 12px 0;
  font-size: ${({ theme }) => theme.font16}px;
  text-align: center;
`;
const ButtonGroup = styled.div`
  display: flex;
`;
const Button = styled.div`
  flex: 1;
  background-color: #75ff6f;
  color: #202020;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: ${({ theme }) => theme.font18}px;
  height: 50px;

  ${({ cancel }) =>
    cancel &&
    `
      background-color: #202020;
      color: #fff;
    `}

  ${({ auto }) =>
    auto &&
    `
      background-color: #e94f1f;
      color: #fff;
    `}
`;

const ButtonCenterToggle = styled.div`
  height: 34px;
  padding: 0 16px;
  background-color: rgba(0, 0, 0, 0.15);
  color: ${({ active }) => (active ? "#FC3F00" : "#808080")};
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  top: -34px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ButtonCurrentLocation = styled.div`
  height: 34px;
  padding: 0 16px;
  color: #fc3f00;
  background-color: rgba(0, 0, 0, 0.15);
  font-size: 16px;
  cursor: pointer;
  position: absolute;
  top: -34px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const OrderGuide = ({
  isShow,
  orderListCount,
  deliveriesCount,
  onClickSubmit,
  onClickCancel,
  deliveriesStartedWithLocationTracking,
  onClickSubmitAuto,
  onClickSubmitManual,
  onClickSubmitExclude,
  localCurrentCenter,
  onClickCenterToggle,
  onClickCurrentLocation,
}) => {
  if (deliveriesStartedWithLocationTracking.length > 0) {
    return (
      <Self isShow={isShow}>
        <ButtonCurrentLocation onClick={onClickCurrentLocation}>
          내위치
        </ButtonCurrentLocation>
        <ButtonCenterToggle
          active={localCurrentCenter}
          onClick={onClickCenterToggle}
        >
          {localCurrentCenter ? "중앙ON" : "중앙OFF"}
        </ButtonCenterToggle>
        <GuideText>
          <b>배송순서 지정 후 배송 수행이 가능합니다.</b>
          <br />
          자동 지정: 시스템에서 최적 순서 지정
          <br />
          수동 지정: 배송원이 직접 순서 지정
          <br />({orderListCount}/{deliveriesCount})
        </GuideText>
        <ButtonGroup>
          {deliveriesCount > 6 && (
            <Button auto onClick={onClickSubmitAuto}>
              자동지정
            </Button>
          )}
          <Button onClick={onClickSubmitManual}>수동지정</Button>
          <Button cancel onClick={onClickSubmitExclude}>
            출발건제외
          </Button>
        </ButtonGroup>
      </Self>
    );
  }

  return (
    <Self isShow={isShow}>
      <GuideText>
        배송 순서대로 지도에 마커를 터치해주세요.
        <br />({orderListCount}/{deliveriesCount})
      </GuideText>
      <ButtonGroup>
        <Button onClick={onClickSubmit}>저장</Button>
        <Button cancel onClick={onClickCancel}>
          취소
        </Button>
      </ButtonGroup>
    </Self>
  );
};

export default OrderGuide;
